import { processCsvData } from 'kepler.gl/processors';
import { addDataToMap } from "kepler.gl/actions";

const ROAD_SIGN_DATA = "/road_sign_unique_icon.csv";

export const fetchAndProcessRoadSignData = async (setLayerDataState, dispatch, store) => {
    let roadSignCSVString;
    try {
        const response = await fetch(ROAD_SIGN_DATA);
        if (!response.ok) {
            console.error('Invalid Road Sign CSV data', response.statusText);
        }

        // Parse the JSON data
        roadSignCSVString = await response.text();
        if (!roadSignCSVString) {
            console.error('Invalid Road Sign CSV data');
        }

    } catch(error) {
        console.error('Error fetching Road Sign CSV data:', error);
    }

    setLayerDataState((prev) => ({ ...prev, roadSigns: roadSignCSVString }));

    // Store the fetched data in Redux
    dispatch({ type: 'STORE_TRANSFORMED_ROAD_SIGN_DATA', payload: processCsvData(roadSignCSVString)});
    
    dispatch(
        addDataToMap({
            datasets: [
                {
                    info: { label: "Road Sign", id: "roadsign" },
                    data: processCsvData(roadSignCSVString)
                }
            ],
            options: {
                centerMap: false,
                readOnly: false,
                keepExistingConfig: true
            },
            config: {
            visState: {
                interactionConfig: {
                    tooltip: {
                        id: 'tooltip',
                        enabled : true,
                        compareMode: false,
                        compareType: "absolute",
                        fieldsToShow: {
                            roadsign : [
                                { name: 'Road Sign Type', format: null },
                            ]
                        }
                    },
                    geocoder: {
                        enabled: true
                    }
                },
                layers: [
                    {
                        "id": "i5kyees",
                        "type": "icon",
                        "config": {
                        "dataId": "roadsign",
                        "label": "Road Sign",
                        "color": [
                            231,
                            159,
                            213
                        ],
                        "highlightColor": [
                            252,
                            242,
                            26,
                            255
                        ],
                        "columns": {
                            "lat": "latitude",
                            "lng": "longitude",
                            "icon": "icon"
                        },
                        "isVisible": true,
                        "visConfig": {
                            "radius": 16.2,
                            "fixedRadius": false,
                            "opacity": 0.8,
                            "outline": false,
                            "thickness": 2,
                            "strokeColor": null,
                            "colorRange": {
                            "colors": [
                                "#edf8b1",
                                "#7fcdbb",
                                "#2c7fb8"
                            ],
                            "name": "Uber Viz Qualitative",
                            "type": "qualitative",
                            "category": "Uber"
                            },
                            "strokeColorRange": {
                            "name": "Global Warming",
                            "type": "sequential",
                            "category": "Uber",
                            "colors": [
                                "#4C0035",
                                "#880030",
                                "#B72F15",
                                "#D6610A",
                                "#EF9100",
                                "#FFC300"
                            ]
                            },
                            "radiusRange": [
                            0,
                            50
                            ],
                            "filled": true,
                            "billboard": false,
                            "allowHover": true,
                            "showNeighborOnHover": false,
                            "showHighlightColor": true
                        },
                        "hidden": false,
                        },
                        // visualChannels: {
                        //     colorField: {
                        //         name: "label_class",
                        //         format: "",
                        //         type: "string",
                        //         analyzerType: "STRING",
                        //         fieldIdx: 0,
                        //         id: "label_class",
                        //         displayName: "label_class"
                        //     },
                        // }
                    }
                ]
            }
            }
        })
    );
    
    console.log("Current Map Configuration road sign:", store.getState());

};